import styled from "@emotion/styled";
import { Skeleton, SkeletonProps } from "@mui/material";

interface CustomSkeletonProps extends SkeletonProps {
  width?: string;
  height?: string;
}

const CustomSkeleton = styled(Skeleton)`
  max-width: clamp(200px, 85%, 480px);
  display: block;
  margin-bottom: 0.75rem;
  max-height: 360px;
  object-fit: cover;
  object-position: center;

  ${(p) => p.theme.media.laptopDown} {
    width: 100%;
    max-width: 90%;
    height: clamp(150px, 40vw, 280px);
  }
`;

export const ImageFallback = (props: CustomSkeletonProps) => {
  const { width: $width, height: $height, ...rest } = props;
  return (
    <CustomSkeleton
      variant="rectangular"
      {...rest}
      sx={{
        height: $height ? $height : "auto",
        width: $width ? $width : "100%",
      }}
    />
  );
};
